import React from 'react'; // eslint-disable-line

const PageBreak = () => {
    return (
        <div className="page-break" />
    );
};
export default PageBreak;
